import { useState } from "react";
import type { CourtSceneProps } from "../helpers/types";

export function CourtScene({ room, idx, snapUrl }: Readonly<CourtSceneProps>) {
  const isOffline = room.status === "offline";
  const isPaused = room.status === "paused";
  const [imgLoaded, setImgLoaded] = useState(false);

  const heads = [3, 4, 2, 3, 4, 2, 3, 4, 3, 2][idx % 10];
  const pOff = idx * 3;

  const headPairs = Array.from({ length: heads }, (_, i) => ({
    id: `${room.id}-head-${i}`,
    left: { left: 20 + i * 26 + pOff, top: 36 + (i % 2 ? 2 : 0) },
    right: { right: 22 + i * 24 + pOff, top: 37 + (i % 2 ? 0 : 1) },
  }));

  const opacity = isOffline ? 0.35 : isPaused ? 0.6 : 1;

  return (
    <div
      className="absolute inset-0 overflow-hidden"
      style={{
        background: room.bg,
        opacity,
        filter: isOffline ? "grayscale(1)" : "none",
      }}
    >
      {/* Ambient glow */}
      <div
        className="absolute left-1/2 -translate-x-1/2 -top-3 w-4/5 rounded-full"
        style={{ height: 48, background: room.gl, filter: "blur(18px)", opacity: 0.7 }}
      />

      {/* Bench */}
      <div
        className="absolute left-1/2 -translate-x-1/2"
        style={{
          top: 14,
          width: "52%",
          height: 13,
          background: "linear-gradient(180deg,#2e1b07,#180d02)",
        }}
      />

      {/* Heads */}
      {headPairs.map(h => (
        <div key={h.id}>
          <div
            className="absolute rounded-full bg-stone-950"
            style={{ width: "8px", height: "8px", ...h.left }}
          />
          <div
            className="absolute rounded-full bg-stone-950"
            style={{ width: "8px", height: "8px", ...h.right }}
          />
        </div>
      ))}

      {/* Snapshot overlay — live/flagged ke liye SVG ke upar render hoga */}
      {snapUrl && (
        <img
          key={snapUrl}
          src={snapUrl}
          alt="snapShot_Frame"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ opacity: imgLoaded ? 1 : 0, transition: "opacity 0.3s" }}
          onLoad={() => setImgLoaded(true)}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      )}

      {/* Paused overlay */}
      {isPaused && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/40">
          <span style={{ fontSize: "28px", color: "rgba(255,255,255,.18)" }} aria-hidden="true">
            ⏸
          </span>
        </div>
      )}

      {/* Offline overlay */}
      {isOffline && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-black/80">
          <div style={{ fontSize: "10px", color: "rgba(255,255,255,.5)", textAlign: "center" }}>
            {room.offReason}
          </div>
          {room.nextSession && (
            <div style={{ fontSize: "9px", color: "rgba(255,255,255,.3)" }}>
              Next: {room.nextSession}
            </div>
          )}
        </div>
      )}
    </div>
  );
}